export default __webpack_public_path__ + "static/media/home-digital-agency-img-06.2b4d1383.jpg";